export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpenEprofileKorabbiMutet');
    },
    closeForm({commit}) {
        commit('setFormCloseEprofileKorabbiMutet');
    }
}
